import { render } from "./ReaderSearchBar.vue?vue&type=template&id=4f2c54cd"
import script from "./ReaderSearchBar.vue?vue&type=script&lang=js"
export * from "./ReaderSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__